const initialState = {
  permission: [],
  allowedPermission: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case "ALLOWED_PERMISSIONS": {
      return {
        ...state,
        allowedPermission: payload,
      };
    }
    default: {
      return state;
    }
  }
};
